import React from 'react';
import styles from '../../styles/Footer.module.css';
import MailIcon from './MailIcon';

interface FooterProps {
  contactText?: string;
  companyName?: string;
  websiteUrl?: string;
  websiteText?: string;
  year?: number;
  className?: string;
}

const Footer = ({
  contactText = 'contact us',
  companyName = 'Gotedo',
  // websiteUrl = 'https://hellogotedo.com',
  // websiteText = 'hellogotedo.com',
  year = new Date().getFullYear(),
  className = '',
}: FooterProps) => {
  return (
    <footer className={`${styles.footer} ${className}`} data-lk-theme="default">
      <h2 className={styles.contact}>
        Are you having issues? please
        <a className={styles.contactText} target="_blank" href="https://support.gotedo.com">
          {contactText}
        </a>
      </h2>

      <p className={styles.copyright}>
        © {companyName} {year}
      </p>
    </footer>
  );
};

export default Footer;
